<template>
    <div class="shows">
        <div v-if="playingTitle" class="player-container">
            <v-container fluid>
                <v-row>
                    <v-col xs="12" sm="10" md="8" offset-sm="1" offset-md="2">
                        <h3 v-if="$attrs.titleType === 'movie'" class="player-show-title" v-on:click="backToTitle">
                            {{titleData.year}} - {{titleData.title}}
                        </h3>
                        <h3 v-if="$attrs.titleType === 'show'" class="player-show-title" v-on:click="backToTitle">
                            {{episode.title}} - Season {{episode.season}} - Episode {{episode.episode}}
                        </h3>
                        <br>
                        <div v-if="useCluster">
                        <v-alert v-if="videoSeed" color="#2b2b2b" dark class="text-center mb-0">
                        <span v-if="seedData.completed" class="title-seeding-text">
                          Seeding {{$attrs.titleType}}: {{formatBytes(seedData.completed)}} / {{formatBytes(seedData.total)}} - From {{seedData.peers}} seeds
                        </span>
                          <span v-else class="title-seeding-text">
                          Starting {{$attrs.titleType}} Seeder
                      </span>
                          <v-progress-linear
                                  class="mt-2 mb-2"
                                  v-model="seedPercentage"
                                  :value="seedPercentage"
                                  :indeterminate="query"
                                  :query="true"
                                  color="red"
                          ></v-progress-linear>
                        </v-alert>
                        </div>
                      <div v-else>
                        <v-alert v-if="videoSeed" color="#2b2b2b" dark class="text-center mb-0">
                            <span class="title-seeding-text">
                              <span v-if="toLong" v-on:click="retryVideo">
                                 Not playing yet? Click here to retry
                              </span>
                              <span v-else>
                                Starting {{$attrs.titleType}}
                              </span>
                            </span>
                            <v-progress-linear
                                    class="mt-2 mb-2"
                                    v-model="seedPercentage"
                                    :value="seedPercentage"
                                    :indeterminate="query"
                                    :query="true"
                                    color="red"
                            ></v-progress-linear>
                        </v-alert>
                      </div>
                        <video v-if="$attrs.titleType === 'movie'" class="video-player" id="movieVideoPlayer"
                               crossorigin="anonymous" playsinline
                               :poster="titleData.images.fanart"
                               :src="videoData.videoSource"
                        >
                            <source v-if="videoData.videoSource" :src="videoData.videoSource"
                                    type='application/vnd.apple.mpegurl'>
                            <track v-for="subtitle in availableSubtitles" v-bind:key="subtitle.langcode"
                                   :default="subtitle.langcode === userLang" kind="subtitles" :label="subtitle.lang"
                                   :srclang="subtitle.langcode"
                                   :src="'//api.maikaelev.com/subtitle?lang='+subtitle.langcode+'&id='+titleData.imdb_id+'&filename='+videoData.fileName">
                        </video>
                        <video v-if="$attrs.titleType === 'show'" class="video-player" id="showVideoPlayer"
                               crossorigin="anonymous" playsinline
                               :poster="titleData.images.fanart"
                               :src="videoData.videoSource"
                        >
                            <source v-if="videoData.videoSource" :src="videoData.videoSource"
                                    type='application/vnd.apple.mpegurl'>
                            <track v-for="subtitle in availableSubtitles" v-bind:key="subtitle.langcode"
                                   :default="subtitle.langcode === userLang" kind="subtitles" :label="subtitle.lang"
                                   :srclang="subtitle.langcode"
                                   :src="'//api.maikaelev.com/subtitle?lang='+subtitle.langcode+'&id='+titleData.imdb_id+'&season='+episode.season+'&episode='+episode.episode+'&filename='+videoData.fileName">
                        </video>

                        <iframe class="mt-8 d-block" data-aa="1301094"
                                src="//acceptable.a-ads.com/1301094?size=Adaptive&background_color=1b1e21&text_color=ffffff&title_color=e2000d&title_hover_color=c7030e&link_color=e2000d&link_hover_color=c7030e"
                                scrolling="no"
                                style="width: 100%; max-height: 100px; height: 100%; border:0px; padding:0; overflow:hidden"
                                allowtransparency="true"></iframe>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <div v-else class="show-container">
            <div v-if="loading" class="loading">
                <Loading></Loading>
            </div>
            <div v-else-if="titleData" class="content">
                <v-container fluid>
                    <v-row>
                        <v-col sm="5" xs="12" align="center">
                            <v-img
                                    :src="titleData.images.poster"
                                    max-width="360"
                            ></v-img>
                        </v-col>
                        <v-col sm="7" xs="12">
                            <h2>{{titleData.title}}</h2>
                            <div class="show-info">
                                <span class="show-year">{{titleData.year}}</span>
                                &bull;
                                <span class="show-runtime">Duration: {{titleData.runtime}} min</span>
                                <span class="show-genres" v-for="genre in titleData.genres" v-bind:key="genre"> &bull; {{genre}}</span>
                            </div>
                            <v-rating class="d-inline-block"
                                      v-model="rating"
                                      half-increments
                                      background-color="red"
                                      :dense=true
                                      full-icon="fa-star"
                                      color="red"
                                      readonly
                                      small
                                      half-icon="fa-star-half-alt"
                            ></v-rating>
                            <span class="rating-text">({{ $attrs.titleType === 'movie' ? titleData.rating.percentage : titleData.rating.percentage/10 }}/10)</span>
                            <p class="mt-3 pr-4">
                                {{titleData.synopsis}}
                            </p>
                            <div class="watch-container">
                                <h3 class="mb-2">Watch</h3>
                                <div v-if="loadingTitle" class="loading-show">
                                    <div class="float-left">
                                        <Loading></Loading>
                                    </div>
                                    <h4 class="float-left loading-text">Loading video source... Please Wait</h4>
                                </div>
                                <div v-else>
                                    <div v-if="$attrs.titleType === 'movie'">
                                        <v-btn large depressed min-width="100" outlined target="_blank" tile
                                               :href="titleData.trailer">
                                            Trailer
                                        </v-btn>
                                        <span v-for="(value,key) in titleData.torrents.en" v-bind:key="key">
                                            <v-tooltip v-if="key!=='2160p'" top>
                                              <template v-slot:activator="{ on }">
                                                  <v-btn :quality="key" large tile outlined v-on="on" v-on:click="loadMovie" min-width="100"
                                                         depressed>
                                                  <span v-if="key==='480p'">SD</span>
                                                  <span v-if="key==='720p'">HD</span>
                                                  <span v-if="key==='1080p'">Full HD</span>
                                                  <span v-if="key==='2160p'">4K</span>
                                                </v-btn>
                                              </template>
                                              <span v-if="key==='480p'">Standard Definition - Load Fast</span>
                                              <span v-if="key==='720p'">High Definition - Recommended</span>
                                              <span v-if="key==='1080p'">Full Definition - Load Slow</span>
                                              <span v-if="key==='2160p'">4K - Load Very Slow</span>
                                            </v-tooltip>
                                        </span>
                                    </div>
                                    <v-expansion-panels v-if="$attrs.titleType === 'show'" active-class="season-active"
                                                        v-model="selectedSeason">
                                        <v-expansion-panel v-for="(season, key) in seasons" v-bind:key="key">
                                            <v-expansion-panel-header>Season {{key+1}}</v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                                <v-expansion-panels v-model="selectedEpisode">
                                                    <v-expansion-panel v-for="episode in season"
                                                                       v-bind:key="episode.tvdb_id">
                                                        <v-expansion-panel-header>{{episode.episode}}.
                                                            {{episode.title}}
                                                        </v-expansion-panel-header>
                                                        <v-expansion-panel-content>
                                                            {{episode.overview}}
                                                            <h4 class="mt-3 mb-2">Watch: </h4>
                                                            <span v-for="(torrent,key) in episode.torrents"
                                                                  v-bind:key="key">
                                                                <v-tooltip top>
                                              <template v-slot:activator="{ on }">
                                                  <v-btn :quality="key" large tile outlined v-on="on" :episodeindex="episode.index" v-on:click="loadShow" min-width="100"
                                                         depressed>
                                                      <span v-if="key==='0'">TV</span>
                                                  <span v-if="key==='480p'">SD</span>
                                                  <span v-if="key==='720p'">HD</span>
                                                  <span v-if="key==='1080p'">Full HD</span>
                                                  <span v-if="key==='2160p'">4K</span>
                                                </v-btn>
                                              </template>
                                              <span v-if="key==='0'">TV Definition - Load Fast</span>
                                              <span v-if="key==='480p'">Standard Definition - Load Fast</span>
                                              <span v-if="key==='720p'">High Definition - Recommended</span>
                                              <span v-if="key==='1080p'">Full Definition - Load Slow</span>
                                              <span v-if="key==='2160p'">4K - Load Very Slow</span>
                                            </v-tooltip>
                            </span>
                                                        </v-expansion-panel-content>
                                                    </v-expansion-panel>
                                                </v-expansion-panels>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                    <iframe class="mt-8 d-block" data-aa="1301094"
                                            src="//acceptable.a-ads.com/1301094?size=Adaptive&background_color=1b1e21&text_color=ffffff&title_color=e2000d&title_hover_color=c7030e&link_color=e2000d&link_hover_color=c7030e"
                                            scrolling="no"
                                            style="width: 100%; max-height: 100px; height: 100%; border:0px; padding:0; overflow:hidden"
                                            allowtransparency="true"></iframe>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
                <script type="application/ld+json">
                  {
                    "@context": "http://schema.org",
                    "@type": "Movie",
                    "aggregateRating": {
                        "@type": "AggregateRating",
                        "bestRating": "100",
                        "ratingCount": {{titleData.rating.votes}},
                        "ratingValue": {{titleData.rating.percentage}}
                    },
                    "image": "{{titleData.images.poster}}",
                    "dateCreated": {{titleData.year}},
                    "description": "{{titleData.synopsis}}",
                    "name": "{{titleData.title}}"
                  }
                </script>
            </div>
        </div>
    </div>
</template>
<style>
    .loading {
        text-align: center;
        font-size: 20px;
        margin-top: 20px;
    }

    .show-info {
        margin: 5px 0;
    }

    .rating-text {
        font-size: 12px;
        margin-left: 5px;
        margin-top: 5px;
    }

    .watch-container {
        padding-top: 20px;
        margin-bottom: 10px;
    }

    .loading-text {
        margin-top: 5px;
        margin-left: 15px;
    }

    .show-genres {
        text-transform: capitalize;
    }

    .player-show-title {
        cursor: pointer;
    }

    .video-player {
        width: 100%;
        outline: none;
    }

    .title-seeding-text{
      text-transform: capitalize;
    }

    .season-active > .v-expansion-panel-content > .v-expansion-panel-content__wrap {
        padding: 0 !important;
    }
</style>
<script>
    import Loading from '@/components/Loading';
    import axios from 'axios';

    export default {
        components: {
            Loading
        },
        data() {
            return {
                loading: false,
                loadingTitle: false,
                notSupported: false,
                playingTitle: false,
                toLong: false,
                query: true,
                seedPercentage: 0,
                selectedSeason: -1,
                selectedEpisode: -1,
                rating: 0,
                titleData: null,
                error: null,
                seedData: {
                    total: 0,
                    completed: 0,
                    peers: 0
                },
                isHLS: false,
                videoSeed: true,
                episode: {},
                videoData: {},
                seasons: [],
                availableSubtitles: [],
                userLang: (navigator.language || navigator.userLanguage).split('-')[0]
            }
        },
        created() {
            this.fetchData();

        },
        watch: {
            selectedSeason: function (newVal, oldVal) {
                if (oldVal !== -1) {
                    this.selectedEpisode = -1;
                }
                if (newVal > -1) {
                    this.$router.replace({
                        ...this.$router.currentRoute,
                        query: {s: newVal + 1}
                    });
                } else {
                    this.$router.replace({
                        ...this.$router.currentRoute,
                        query: {}
                    });
                }
            },
            selectedEpisode: function (newVal) {
                if (newVal > -1) {
                    this.$router.replace({
                        ...this.$router.currentRoute,
                        query: {s: this.selectedSeason + 1, e: newVal + 1}
                    });
                } else {
                    this.$router.replace({
                        ...this.$router.currentRoute,
                        query: {s: this.selectedSeason + 1}
                    });
                }
            }
        },
        methods: {
            backToTitle() {
                this.toLong = false;
                this.playingTitle = false;
                this.loadingTitle = false;
                this.seedPercentage = 0;
                this.statClient.close && this.statClient.close();
            },
            retryVideo(){
              this.backToTitle();
              this.loading = true;
              var self = this;
              self._.delay(function(){
                self.loading = false;
                self.playTitleVideo();
              }, 2000);
            },
            formatBytes(bytes, decimals = 2) {
                if (bytes === 0) return '0 Bytes';
                const k = 1024;
                const dm = decimals < 0 ? 0 : decimals;
                const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
                const i = Math.floor(Math.log(bytes) / Math.log(k));
                return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
            },
            loadSubtitles() {
                this.loadingTitle = true;
                var self = this;
                var subtitlesParams = {};
                if (this.$attrs.titleType === 'show') {
                    subtitlesParams = {
                        id: self.titleData.imdb_id,
                        filename: self.videoData.fileName,
                        season: self.episode.season || '',
                        episode: self.episode.episode || ''
                    }
                }
                if (this.$attrs.titleType === 'movie') {
                    subtitlesParams = {
                        id: self.titleData.imdb_id,
                        filename: self.videoData.fileName
                    }
                }
                axios.get('//api.maikaelev.com/subtitles', {
                    params: subtitlesParams
                }).then(function (response) {
                    self.availableSubtitles = self._.sortBy(response.data, function (sub) {
                        return sub.lang
                    });
                })
            },
            getVideoFile: function (files) {
                return this._.find(files, function (file) {
                    return file.path.indexOf('.mp4') > -1 ||
                        file.path.indexOf('.webm') > -1 ||
                        file.path.indexOf('.m4v') > -1 ||
                        file.path.indexOf('.mkv') > -1 ||
                        file.path.indexOf('.avi') > -1
                });
            },
            loadShowFromUrl(query) {
                var episodeIndex = this._.findIndex(this.titleData.episodes, {
                    season: parseInt(query.s),
                    episode: parseInt(query.e)
                });
                this.episode = this.titleData.episodes[episodeIndex];
                this.proxyTitle(query.q);
            },
            loadShow(event) {
                var episodeIndex = event.currentTarget.getAttribute('episodeindex');
                var quality = event.currentTarget.getAttribute('quality');
                this.episode = this.titleData.episodes[episodeIndex];
                this.proxyTitle(quality);
            },
            loadMovie(event) {
                var quality = event.currentTarget.getAttribute('quality');
                this.proxyTitle(quality);
            },
            proxyTitle(quality) {
                if(this.useCluster){
                  this.loadTitleVideoTorrent(quality, this.$attrs.titleType)
                }else{
                  this.loadTitleVideo(quality, this.$attrs.titleType)
                }

            },
            loadTitleVideo(quality, type) {
                var self = this;
                var magnetUrl;
                this.loadingTitle = true;

                if (type === 'movie') {
                    magnetUrl = this.titleData.torrents.en[quality].url;
                } else {
                    magnetUrl = this.episode.torrents[quality].url;
                }
                axios.get('//www.maikaelev.com/video', {
                    //timeout: 15000,
                    params: {
                        magnet: encodeURIComponent(magnetUrl)
                    }
                }).then(function (response) {
                    self.videoData = response.data;
                    self.playTitleVideo();
                    self.loadSubtitles();
                })
            },
            playTitleVideo(){
              var self = this;
              self.loadingTitle = false;
              self.playingTitle = true;
              self.isHLS = self.videoData.fileName.indexOf('.mkv') > -1 || self.videoData.fileName.indexOf('.avi') > -1;
              self._.defer(function () {
                var video = document.getElementById(self.$attrs.titleType + 'VideoPlayer');
                if (self.isHLS) {
                  if (window.Hls.isSupported()) {
                    var hls = new window.Hls({startPosition: 0});
                    hls.loadSource(self.videoData.videoSource);
                    hls.attachMedia(video);
                    hls.on(window.Hls.Events.MANIFEST_PARSED, function () {
                      video.play();
                    });
                  }
                }
                self._.delay(function(){
                  self.toLong = true;
                }, 30000);
                video.addEventListener( "loadedmetadata", function () {
                  self.videoSeed = false;
                  if(!video.controls){
                      video.controls = true;
                  }
                  video.play();
                });
              });
            },
            loadTitleVideoTorrent(quality, type) {
                var self = this;
                var magnetUrl;
                this.loadingTitle = true;
                self.seedData = {total: 0, completed: 0, peers: 0};

                if (type === 'movie') {
                  magnetUrl = this.titleData.torrents.en[quality].url;
                } else {
                  magnetUrl = this.episode.torrents[quality].url;
                }
                if ((!(this.episode && this.episode.torrents && this.episode.torrents[quality])) && type !== 'movie') {
                    this.loadingTitle = false;
                    return;
                }
                /*
                this.$router.replace({
                  ...this.$router.currentRoute,
                  query: {s: this.selectedSeason+1, e: this.selectedEpisode+1, q: quality}
                });
                 */
                async function loadVideo() {
                    let torrent;
                    if(type === 'movie'){
                        torrent = await self.videoSDK.torrent.fromUrl(magnetUrl);
                    }else{
                        torrent = await self.videoSDK.magnet.fetchTorrent(magnetUrl);
                    }
                    const expire = 60 * 60 * 24;
                    await self.videoSDK.torrent.push(torrent, expire);
                    const seeder = self.videoSDK.seeder.get(torrent.infoHash);
                    const file = self.getVideoFile(torrent.files);
                    const url = await seeder.streamUrl(file.path);
                    self.isHLS = file.name.indexOf('.mkv') > -1 || file.name.indexOf('.avi') > -1;
                    self.videoData = {
                        videoSource: url.href,
                        fileName: file.name
                    };
                    self.loadSubtitles();
                    self.loadingTitle = false;
                    self.playingTitle = true;
                    let firstLoad = true;
                    let statClient = seeder.stats(file.path, (path, data) => {
                        var video = document.getElementById(self.$attrs.titleType + 'VideoPlayer');
                        if (self.isHLS && firstLoad) {

                            if (window.Hls.isSupported()) {
                                var hls = new window.Hls({startPosition: 0});
                                hls.loadSource(url.href);
                                hls.attachMedia(video);
                                hls.on(window.Hls.Events.MANIFEST_PARSED, function () {
                                    if(!video.controls){
                                        video.controls = true;
                                    }
                                  video.play();
                                });
                            }
                        }else{
                          if(data.completed){
                              if(!video.controls){
                                  video.controls = true;
                              }
                            video.play();
                          }
                        }
                        if(data.completed){
                          self.query = false;
                        }
                        firstLoad = false;
                        self.seedData = data;
                        self.seedPercentage = data.completed * 100 / data.total;
                    });
                    self.$store.state.statClient = statClient;
                    self.statClient = statClient;
                }
                loadVideo();
            },
            openSeason(s) {
                this.selectedSeason = (parseInt(s) - 1);
            },
            openEpisode(s, e) {
                this.selectedSeason = (parseInt(s) - 1);
                this.selectedEpisode = (parseInt(e) - 1);
            },
            getAllTorrents(startAt, startData){
                let self = this;
                axios.get('https://eztv.io/api/get-torrents', {
                    params: {
                        imdb_id: this.$route.params.id.split('_')[0].replace('tt',''),
                        limit: 100,
                        page: startAt
                    }
                }).then(function (response) {
                    if((response.data.torrents_count/100)>startAt){
                        console.log("La fiesta debe contiunar",startData)
                        self.getAllTorrents(startAt+1, self._.extend(startData,{},response.data.torrents))
                    }else{
                        console.log("Tamo ready",self._.extend(startData,{},response.data.torrents))
                        self.episodes = self._.extend(startData,{},response.data.torrents);

                    }
                });
            },
            createSeasons() {
                var seasons = [];
                var self = this;
                var episodes = this.titleData.episodes;
                for (var i = 0; i < episodes.length; i++) {
                    var episode = episodes[i];
                    var season = parseInt(episodes[i].season) - 1;
                    seasons[season] = seasons[season] || [];
                    episode.index = i;
                    seasons[season].push(episode);
                }
                self._.each(seasons, function (season, index) {
                    seasons[index] = self._.sortBy(season, function (episode) {
                        return episode.episode
                    })
                });
                seasons = self._.map(seasons, function (season) {
                    if (season.length) {
                        return season;
                    }
                    return null;
                });
                this.seasons = this._.compact(seasons);
                console.log(this.seasons);
            },
            mapMovieResponse(data) {
                return this._.extend(data, {
                    imdb_id: data.imdb_code,
                    trailer: 'https://www.youtube.com/watch?v='+data.yt_trailer_code,
                    synopsis: data.description_full,
                    images: {
                        poster: data.large_cover_image,
                        fanart: data.background_image_original
                    },
                    rating: {
                        percentage: data.rating
                    },
                    torrents: {
                        en: this.createTorrents(data.torrents)
                    }
                });
            },
            mapShowResponse(data) {
                return data;
                /*
                return this._.extend(data, {
                    imdb_id: data.imdb_code,
                    year: data.premiered.split('-')[0],
                    title: data.name,
                    synopsis: data.summary,
                    images: {
                        poster: data.image.medium,
                        fanart: data.background_image_original
                    },
                    rating: {
                        percentage: data.rating.average*10
                    },
                    torrents: {
                        en: this.createTorrents(data.torrents)
                    }
                });

                 */
            },
            createTorrents(torrents){
                let legacyTorrents = {};
                this._.each(torrents, function (torrent) {
                    if(torrent.quality === '3D'){
                        return;
                    }
                    if(legacyTorrents[torrent.quality]){
                        if(legacyTorrents[torrent.quality].seed < torrent.seed){
                            legacyTorrents[torrent.quality] = torrent;
                        }
                    }else{
                        legacyTorrents[torrent.quality] = torrent;
                    }
                });
                return legacyTorrents;
            },
            fetchData() {
                var self = this;
                this.error = this.titleData = null;
                const titleType = this.$attrs.titleType;
                let url;
                let params = {};
                this.loading = true;

                if (titleType === 'movie') {
                    axios.get('https://yts.mx/api/v2/list_movies.json', {
                        params: {
                            query_term: this.$route.params.id.split('_')[0]
                        }
                    }).then(function (response) {
                        params = {
                            movie_id: response.data.data.movies[0].id
                        }
                        axios.get('https://yts.mx/api/v2/movie_details.json', {
                            params: params
                        }).then(function (response) {
                            self.loading = false;
                            self.titleData = self.mapMovieResponse(response.data.data.movie);
                            document.title = self.titleData.title + ' ' + self.titleData.year + ' - MaikaElev - ';
                            self.rating = self.titleData.rating.percentage * 10;
                        })
                    })
                }else{
                    url = '//api.maikaelev.com/popxy/show/' + this.$route.params.id.split('_')[0];
                    axios.get(url).then(function (response) {
                        self.loading = false;
                        self.titleData = self.mapShowResponse(response.data);
                        document.title = self.titleData.title + ' ' + self.titleData.year + ' - MaikaElev - ';
                        self.rating = self.titleData.rating.percentage * 5 / 100;
                        if (self.$attrs.titleType === 'show') {
                            //self.getAllTorrents(1, {});
                            self.createSeasons();
                            const q = self.$route.query;
                            if (q.s && q.e && q.q) {
                                self.loadShowFromUrl(q);
                            } else if (q.s && !q.e && !q.q) {
                                self.openSeason(q.s);
                            } else if (q.s && q.e && !q.q) {
                                self.openEpisode(q.s, q.e);
                            }
                        }
                    })
                }


            }
        }
    }
</script>